/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, February 2022
 * @format
 * @flow
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Button from '../../../../../components/Button';
import modeEnums from '../../../../../enums/modeEnums';
import FireboardUtils from '../../../../../util/fireboard-util';
import classes from './CheckCardFooter.module.css';

const BUTTON_CONFIG = {
  [modeEnums.TABLE_DELIVERY]: [
    {
      key: 'notify',
      name: 'Notify',
    },
    {
      key: 'complete',
      name: 'Complete',
    },
  ],
  [modeEnums.GPS_LOCATION]: [
    {
      key: 'notify',
      name: 'Notify',
    },
    {
      key: 'delivered',
      name: 'Delivered',
    },
  ],
};

const CheckCardFooter = ({ onClickCheckFooterButton, check, mode, isCheckSelected }) => {
  const [buttons, setButtons] = useState([]);
  const { data: storeInfo } = useSelector(state => state.storeInfo);

  useEffect(() => {
    let buttons = BUTTON_CONFIG[mode];
    if (mode === modeEnums.GPS_LOCATION &&
      FireboardUtils.isViewOnMapOptionVisible(storeInfo?.enableGpsLocation, storeInfo?.latitude, storeInfo?.longitude, check?.orders)) {
      buttons = [...buttons, {
        key: 'viewOnMap',
        name: 'View on Map'
      }];
    }
    setButtons(buttons);
  }, [mode, storeInfo, check]);

  return (
    <div className={classes.buttonWrapper}>
      {buttons.map(button =>
        <Button
          key={button.key}
          className={classNames({ [classes.button]: true, [classes.highlightedBtn]: isCheckSelected })}
          onClick={() => onClickCheckFooterButton(button.key, check)}
        >
          <span className={classNames({ [classes.buttonText]: true, [classes.highlightedBtnTxt]: isCheckSelected })}>{button.name}</span>
        </Button>
      )}
    </div>
  );
};

export default CheckCardFooter;

CheckCardFooter.propTypes = {
  onClickCheckFooterButton: PropTypes.func,
  check: PropTypes.object,
  currentMode: PropTypes.string,
  isCheckSelected: PropTypes.bool,
};

CheckCardFooter.defaultProps = {
  onClickCheckFooterButton: () => { },
  check: {},
  currentMode: modeEnums.TABLE_DELIVERY,
  isCheckSelected: false,
};
